import React from 'react';
import get from 'lodash/get';
import pick from 'lodash/pick';
import { connect } from 'react-redux';
import NavigationComponent from 'common-ui-components/dist/components/Organisms/Navigation';
import errorBoundary from '../../../utils/errorBoundary';

const Navigation = props => (
  <NavigationComponent
    {...pick(props, 'pageData', 'config', 'isNavigationV2Enabled', 'mobileData')}
    {...props}
  />
);

export const mapStateToProps = state => ({
  pageData: get(state, ['global', 'globalData', 'pageData', 'Navigation Content', 'items'], {}),
  config: get(state, ['global', 'globalData', 'config'], {}),
  isNavigationV2Enabled: get(
    state,
    ['global', 'globalData', 'pageData', 'Page Content', 'isNavigationV2Enabled'],
    false
  ),
  mobileData: get(state, ['global', 'globalData', 'pageData', 'Navigation Content'], {}),
});

export default connect(mapStateToProps)(errorBoundary(Navigation));
